import { Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { useGetTransmissionAnalyticQuery } from "app/store/dashboard/transmission_analytic/api/transmissionAnalyticApi";
import Loading from "components/common/loading/Loading";
import TransmissionChart from "components/pages/dashboard/transmission_analytic/chart/TransmissionChart";

import TransmissionAnalyticAccountFilter from "./filters/TransmissionAnalyticAccountFilter";
import TransmissionAnalyticDateFilter from "./filters/TransmissionAnalyticDateFilter";
import { showErrorToast } from "utils/toast";

const TransmissionAnalytic = () => {
  const { accountFilter, startDate, endDate } = useSelector(
    (state) => state.transmissionAnalytic
  );
  const { data, isLoading, isFetching, isError, error } =
    useGetTransmissionAnalyticQuery(
      { account: accountFilter, startDate, endDate },
      {
        refetchOnMountOrArgChange: true,
      }
    );

  useEffect(() => {
    if (isError && error?.message) {
      showErrorToast(error?.message);
    }
  }, [isError]);

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
          spacing={1}
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                fontSize: "1.125rem",
                fontWeight: 500,
              }}
            >
              Total Transmissions
            </Typography>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" spacing={1}>
              <TransmissionAnalyticAccountFilter />
              <TransmissionAnalyticDateFilter />
            </Grid>
          </Grid>
        </Grid>
        {isLoading || isFetching ? (
          <Loading height="300px" />
        ) : (
          <Grid container flex flexDirection={"column"}>
            <TransmissionChart data={data} />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default TransmissionAnalytic;
